import React, { useEffect, useRef } from 'react';

const HauntedDust = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        let animationFrameId;
        let particles = [];
        let isAnimating = false; 

        const resize = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };
        window.addEventListener('resize', resize);
        resize();

        class Particle {
            constructor() {
                this.x = Math.random() * canvas.width;
                this.y = Math.random() * canvas.height;
                this.size = Math.random() * 2 + 1;
                this.speedY = Math.random() * 0.3 + 0.1;
                this.speedX = (Math.random() - 0.5) * 0.15;
                this.baseOpacity = Math.random() * 0.5 + 0.3;
                this.life = Math.random() * 100;
            }

            update() {
                this.y -= this.speedY;
                this.x += this.speedX + Math.sin(this.life * 0.05) * 0.2;
                this.life += 0.02;

                if (this.y < 0 - this.size) {
                    this.y = canvas.height + this.size;
                    this.x = Math.random() * canvas.width;
                }

                const currentOpacity = this.baseOpacity + Math.sin(this.life * 2) * 0.15;
                this.draw(currentOpacity);
            }

            draw(opacity) {
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(166, 0, 255, ${opacity})`;
                ctx.fill();
            }
        }

        const initParticles = () => {
            particles = [];
            
            const particleCount = Math.min(Math.floor(window.innerWidth / 15), 120);
            for (let i = 0; i < particleCount; i++) {
                particles.push(new Particle());
            }
        };


        const animate = () => {
            if (!isAnimating) return;
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            const connectionDistance = 130;
            const connectionDistanceSq = connectionDistance * connectionDistance; 

            for (let i = 0; i < particles.length; i++) {
                for (let j = i + 1; j < particles.length; j++) {
                    const dx = particles[i].x - particles[j].x;
                    const dy = particles[i].y - particles[j].y;
                    const distanceSq = dx * dx + dy * dy; 

                    if (distanceSq < connectionDistanceSq) {
                        
                        const distance = Math.sqrt(distanceSq);
                        const opacity = 1 - (distance / connectionDistance);

                        ctx.beginPath();
                        ctx.moveTo(particles[i].x, particles[i].y);
                        ctx.lineTo(particles[j].x, particles[j].y);
                        ctx.strokeStyle = `rgba(166, 0, 255, ${opacity * 0.6})`;
                        ctx.lineWidth = 0.8;
                        ctx.stroke();
                    }
                }
            }

            particles.forEach(particle => particle.update());
            animationFrameId = requestAnimationFrame(animate);
        };

        
        const startTimeout = setTimeout(() => {
            initParticles();
            isAnimating = true;
            animate();
        }, 150);

        return () => {
            window.removeEventListener('resize', resize);
            clearTimeout(startTimeout);
            isAnimating = false;
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                pointerEvents: 'none',
                zIndex: -1,
            }}
        />
    );
};

export default HauntedDust;